// src/localization/lang.js
export const french = {
  header: {
    logoAlt: "Logo Fast Caution",
    home: "Accueil",
    create: "Créer votre caution",
    pricing: "Tarifs",
    contact: "Contact",
    language: "Langue",
  },
  footer: "Tous droits réservés.",
  home: {
    title: "<0>Fast</0> Caution",
    subtitle: "La solution simple et sécurisée pour vos cautions de location courtes durées*, par carte bancaire.",
    ctaPrimary: "🚀 Créer votre caution en 1 min",
    cardTitle: "Comment ça marche ?",
    step1: "Créez et envoyez une demande de caution à la personne de votre choix, <0>c'est gratuit</0>!",
    step2: "La personne règle sa caution par carte bancaire, sans être débité.",
    step3: "Un sinistre? Encaissez partiellement ou totalement la caution**.",
    cardFooter: "Simple, Basique",
    ctaSecondary: "🚀 Créer votre caution en 1 min",
    disclaimer: "* 7 jours maximum.\n** Si vous restituez la caution, aucun frais ne s'appliquent, c'est gratuit!\nToutefois, si vous encaissez la caution (totalement ou partiellement), des frais de transaction bancaire s'appliqueront (5% + 3€ fixe)."
  },
  contact: {
    title: "Formulaire de contact",
    subtitle: "Un souci, un doute, besoin d'un renseignement ?",
    cardTitle: "Contactez-nous",
    emailLabel: "Votre adresse e-mail",
    subjectLabel: "Objet",
    messageLabel: "Message",
    submitButton: "Envoyer",
    loading: "Envoi en cours...",
    errorEmpty: "Merci de remplir tous les champs.",
    errorInvalidEmail: "Adresse e-mail invalide.",
    success: "Votre message a bien été envoyé. Nous vous répondrons rapidement."
  },
  pricing: {
    title: "Nos tarifs",
    subtitle: "Des prix clairs et transparents.",
    cardTitle: "",
    creationLabel: "Création d'une caution",
    creationValue: "GRATUIT",
    releaseLabel: "Libération de la caution",
    releaseValue: "GRATUIT",
    collectionLabel: "Encaissement de la caution",
    collectionValue: "5% du montant encaissé + 3€",
    footerText: "Simple, Basique 😍",
    cta: "🚀 Créer ma caution"
  },
  checkout: {
    topImageAlt: "Logo Fast Caution",
    title: "",
    subtitle: "La solution simple et sécurisée pour vos cautions de location courtes durées*, par carte bancaire.",
    cardTitle: "Caution",
    referenceLabel: "Référence :",
    requestedByLabel: "Demandé par",
    cta: "Valider votre caution",
    loading: "Chargement...",
    disclaimerStar: "* 7 jours maximum",
    disclaimerText:
      "AUCUN retrait ne sera effectué sur votre compte bancaire (à l'exception des cartes rechargeables et des néo-banques tels que Revolut, N26, etc).\nIl s'agit simplement d'une réservation de la somme indiquée, comme lors d'une location de voiture.\nCela impactera seulement votre plafond de carte bancaire."
  },
  checkoutSuccess: {
    title: "Caution validé!",
    description: "Votre pré-autorisation a été validée avec succès.",
    homeButton: "Retour à l'accueil"
  },
  createDepositSuccess: {
    title: "Votre demande de caution a été envoyée au destinataire 🚀",
    cardTitle: "Mettre à jour mes informations",
    referenceLabel: "Référence :",
    prompt: "⚠️ Indiquez à votre destinataire qui vous êtes",
    firstNameLabel: "Mon prénom",
    lastNameLabel: "Mon nom",
    updateButton: "Mettre à jour mes informations",
    success: "Mise à jour réussie !",
    errorPrefix: "Erreur:",
    loading: "Chargement..."
  },
  createDeposit: {
    title: "Créer votre demande de caution",
    subtitle: "Le destinataire recevra le lien de paiement par email. Une fois réglé, vous serez notifiés à votre tour par email.",
    cardOwnerTitle: "Vous (ou propriétaire)",
    cardOwnerSubtitle: "La personne qui demande la caution",
    cardClientTitle: "Destinataire (ou client)",
    cardClientSubtitle: "La personne qui doit s'acquitter de votre caution",
    ownerEmailLabel: "Votre adresse e-mail",
    depositAmountLabel: "Montant de la caution souhaité",
    ownerClientEmailLabel: "Adresse e-mail du destinataire",
    submitButton: "Envoyer la demande",
    errorTextfieldDeposit: "Le montant doit être compris entre 20 and 2000",
    errorPrefix: "Erreur:",
    errorEmptyFields: "Tous les champs doivent être remplis.",
    errorInvalidEmail: "Les adresses e-mail doivent être valides.",
    errorSameEmail: "L'adresse e-mail du destinataire ne peut pas être identique à la vôtre.",
    errorResponse: "Erreur: Response invalide.",
    captchaNotLoaded: "reCAPTCHA Enterprise n'est pas chargé.",
    loading: "Traitement...",
  },
  collectDeposit: {
    title: "Encaisser la caution",
    description: "Veuillez saisir les informations pour encaisser la caution.",
    labelField: "Montant à encaisser",
    submitButton: "Encaisser",
    loading: "Encaissement en cours...",
    error: "Une erreur est survenue.",
    success: "La caution a été encaissée avec succès.",
    verificationTitle: "Vérification requise",
    verificationSubtitle: "Pour encaisser la caution, vous devez d'abord vérifier votre identité.",
    verificationButton: "Vérifier mon identité",
    pageErrorTitle: "Erreur",
    pageErrorSubtitle: "Les paramètres requis ne sont pas fournis dans l'URL",
  },
  releaseDeposit: {
    title: "Libérer la caution",
    description: "Confirmez que vous souhaitez libérer la caution.",
    submitButton: "Libérer",
    loading: "Libération en cours...",
    success: "La caution a été libérée avec succès.",
    error: "Une erreur est survenue lors de la libération de la caution.",
    pageErrorTitle: "Erreur",
    pageErrorSubtitle: "Les paramètres requis ne sont pas fournis dans l'URL",
  },
  notFound: {
    title: "Page non trouvée",
    description: "Désolé, la page que vous recherchez n'existe pas.",
    homeButton: "Retour à l'accueil"
  }
};